import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { getCurrentUser } from '../services/auth';

// Коренева сторінка: перенаправляє за станом авторизації/роллю.
export default function Home() {
  const [dest, setDest] = useState(null);

  useEffect(() => {
    let ignore = false;
    getCurrentUser().then((u) => {
      if (ignore) return;
      // Гість потрапляє одразу на сторінку запису (може бронювати без акаунта)
      if (!u) setDest('/book');
      else if (u.role === 'master' || u.role === 'admin') setDest('/master/dashboard');
      else setDest('/user/cabinet');
    });
    return () => { ignore = true; };
  }, []);

  if (!dest) return null;
  return <Navigate to={dest} replace />;
}
